import { Bridge } from '..';

interface ISync {
  type: 'sync_from_kernel'
  args: { [key: string]: any }
}

export function sync_from_kernel(b: Bridge, msg: ISync) {
  for (const name of Object.keys(msg.args)) {
    if (b.stateLinks[name]) {
      b.stateLinks[name].restore(msg.args[name])
    } else {
      alert(`unknown link type: ${name}`)
    }
  }
}
